import './AvatarPlaceholder.css';

export default function AvatarPlaceholder({ className = '' }) {
  return (
    <svg className={`avatar-svg ${className}`} aria-hidden='true' focusable='false'>
      <circle cx='50%' cy='40%' r='18%' />
      <circle cx='50%' cy='105%' r='36%' />
    </svg>
  );
}
